import { useEffect, useRef, useState } from 'react';
import Detail from './detail';
import request from '../../../../lib/request';

const EditLog = ({
  dialogRef,
  closeDialog,
  refreshWorkoutTracker,
  selectedId,
  preference,
  user,
  editOpen,
}) => {
  const detailDialogRef = useRef(null);

  const [selectedLog, setSelectedLog] = useState(null);

  useEffect(() => {
    if (editOpen) {
      getWorkoutLog();
    }
  }, [editOpen]);

  const closeDetailDialog = () => {
    closeDialog();
  };

  const getWorkoutLog = async () => {
    try {
      if (selectedId) {
        const { result } = await request.get(`/workout/log/${selectedId}`);
        if (result) {
          setSelectedLog(result);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className='p-4 w-full h-full max-w-lg max-h-full bg-primary'
      onCancel={closeDialog}
    >
      <Detail
        selectedLog={selectedLog}
        dialogRef={detailDialogRef}
        closeDialog={closeDetailDialog}
        refreshWorkoutTracker={refreshWorkoutTracker}
        preference={preference}
        user={user}
      />
    </dialog>
  );
};

export default EditLog;
